import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import headerIcon from '~images/request_permissions.svg';
import { logOut } from '~actions/rootActions';

import { ModalWrapper, Gap } from '~ui-kit';

const OnboardingRequestDonePage = () => {
  const dispatch = useDispatch();

  const onHide = () => {
    dispatch(logOut);
  };

  return (
    <Container>
      <ModalWrapper
        close={onHide}
        title="Pyyntösi odottaa reagointia"
        backText="Sulje paketti"
        backOnClick={onHide}
        headerLargeIcon={headerIcon}
      >
        <p>
          Saat sähköpostiisi viestin, kun palvelukoordinaattori saa lisättyä
          oikean yksikön Pakettiisi.
        </p>
        <p>
          Jos lisäyksessä kestää yli 7 päivää, otathan yhteyttä
          palvelukoordinaattoriin:{' '}
          <a href="mailto:palvelukoordinaattori@pirha.fi">
            palvelukoordinaattori@pirha.fi
          </a>
        </p>
        <Gap />
      </ModalWrapper>
    </Container>
  );
};

const Container = styled.div``;

export default OnboardingRequestDonePage;
